import Icon from 'veui/components/Icon'
import { IconSearch } from 'dls-icons-vue'

Icon.register('search', IconSearch)
